/** @jsxImportSource @emotion/react */
import React from 'react'

import { findReplyByQuestionId, getReplyValue } from '../_helpers/pdfHelpers'
import { formatDate } from '@btime/helpers'
import View from '../../../../components/pdf/View'
import Text from '../../../../components/pdf/Text'
import Separator from '../../../../components/pdf/Separator'
import { useParentServiceOrder } from '../_load/ParentServiceOrderLoader'

const TermsOfUseTemplate = () => {
  const parentServiceOrder = useParentServiceOrder()

  const dateTime = formatDate('DD [de] MMMM [de] YYYY', parentServiceOrder.endDate)
  const name = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 41))
  const maritalStatus = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 4))?.name
  const document = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 10))

  return (
    <View pageBreakAfter>
      <Text bold size={18} align="center" style={{ fontWeight: 700 }}>
        TERMO DE CONSENTIMENTO E ASSENTIMENTO DE AUTORIZAÇÃO DE USO DE IMAGEM E VOZ
      </Text>
      <Separator weight={16} />
      <Text size={14.5} align="justify">
        Neste ato, eu, {name}, nacionalidade brasileiro (a), estado civil {maritalStatus.toLowerCase()}, inscrito (a) no
        CPF/MF sob nº {document}, levando em consideração o direito fundamental à inviolabilidade da imagem, previsto na
        Constituição Federal; a Lei Federal nº 13.709/2018, Lei Geral de Proteção de Dados Pessoais (LGPD); Este TERMO
        DE CONSENTIMENTO E ASSENTIMENTO DE AUTORIZAÇÃO DE USO DE IMAGEM E VOZ foi elaborado em consonância com as
        referidas Leis, que em seu artigo 5º, inciso XII, dispõe que este Termo viabiliza a manifestação livre,
        informada e inequívoca, pela qual o titular/responsável autoriza o tratamento de dados pessoais; que a imagem é
        um dado pessoal, do gênero de dados biométricos que se trata de uma única e exclusiva pessoa, tornando-a
        identificável e que a voz permite identificar, direta ou indiretamente, um indivíduo; espeitando à privacidade,
        intimidade e liberdade, autorizo, nos moldes do artigo 14, § 1º e § 2º, da LGPD a empresa BOSI TERRAPLENAGEM
        LTDA, com sede na cidade de Sete Lagoas, Estado de Minas Gerais, à rua Catalão, nº 2423, galpão 01, sala A,
        bairro Vale das Palmeiras, CEP 35.701.174, inscrita no CNPJ sob o nº 42.855.431/0001-8, para o fim de retratar a
        execução dos serviços prestados, utilizar todo e qualquer material entre fotos, vídeos, áudios, documentos e
        outros meios de mídias e comunicação; Podendo também utilizar minha imagem e áudio para campanhas publicitárias,
        promocionais e institucionais desta empresa, utilizando de veículos: (I) out-door; (II) busdoor; folhetos em
        geral (encartes, mala direta, catálogo etc.); (III) folder de apresentação; (IV) anúncios em revistas e jornais
        em geral; (V) home page; (VI) cartazes; (VII) back-light; (VIII) mídia eletrônica (painéis, vídeo-tapes,
        televisão, cinema, programa para rádio, entre outros). Sejam os arquivos de imagem e voz destinados à divulgação
        ao público em geral e/ou apenas para uso desta empresa, e desde que não haja desvirtuamento da sua finalidade.`
      </Text>

      <Separator weight={6} />

      <Text size={14.5} align="justify">
        A presente autorização é gratuita, abrangendo o uso em todo território nacional e no exterior. Por esta ser a
        manifestação da minha vontade, nada reclamarei a título de direitos conexos à imagem e áudio ou a qualquer
        outro. Meu consentimento é por prazo indeterminado, podendo ser revogado a qualquer tempo através de registro de
        manifestação expressa e gratuita no email: lucas@bosiempreendimentos.com.br.
      </Text>

      <Separator weight={16} />

      <Text size={14.5} align="center">
        Sete Lagoas, {dateTime}
      </Text>

      <Separator weight={18} />

      <Text size={14.5} align="center">
        Assinatura:________________________________________________________________________
      </Text>
    </View>
  )
}

export default TermsOfUseTemplate
